<template>
  <el-card class="h-full">
    <div class="w-full h-full flex flex-col" v-if="currentComp === 'TABLE'" v-loading="loading">
      <div class="flex mb-10px flex-wrap">
        <el-input size="small" class="mr-10px !w-50 mb-10px" placeholder="考试名称" maxlength="50"
          v-model="searchData.ExamName" clearable></el-input>
        <el-input size="small" class="mr-10px !w-50 mb-10px" placeholder="考试编号" maxlength="50"
          v-model="searchData.ExamCode" clearable></el-input>
        <el-date-picker class="mr-10px mb-10px" v-model="searchData.StartTime" format="yyyy-MM-dd HH:mm:ss" size="small"
          type="datetime" :clearable="true" placeholder="开始日期" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        <el-date-picker class="mr-10px mb-10px" v-model="searchData.EndTime" format="yyyy-MM-dd HH:mm:ss" size="small"
          type="datetime" :clearable="true" placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>

        <el-button class="mb-10px" size="small" @click="resetText()">重置</el-button>
        <el-button class="mb-10px" size="small" type="primary" @click="searchList()">搜索</el-button>
        <el-button class="mb-10px" size="small" type="primary" @click="handleEvent(null, 'create')"
          :disabled="!$hasAccess('create')">新增</el-button>
        <el-button type="primary" size="small" class="mr-10px mb-10px" @click="handleExport"
          :loading="exportLoading" v-if="!$hasAccess('export')">导出</el-button>
      </div>
      <div class="flex-auto h-0px">
        <el-table :data="tableData" border class="w-full" :height="tableHeight" stripe v-loading="loading"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="考试名称" prop="ExamName" show-overflow-tooltip />
          <el-table-column label="考试编码" prop="ExamCode" show-overflow-tooltip />
          <el-table-column label="考试开始时间" prop="ExamStartTime" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.ExamStartTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="考试结束时间" prop="ExamEndTime" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.ExamEndTime | formatDate }}
            </template>
          </el-table-column>
          <el-table-column label="考生人数" prop="ExamineeCount" show-overflow-tooltip />
          <el-table-column label="出题策略" prop="Name" show-overflow-tooltip />
          <el-table-column label="考试状态" prop="ExamStateName" show-overflow-tooltip />
          <el-table-column label="操作" width="260">
            <template slot-scope="scope">
              <el-button size="mini" @click.native="handleEvent(scope.row, 'read')"
                :disabled="!$hasAccess('read')">查看</el-button>
              <el-button size="mini" @click.native="handleEvent(scope.row, 'update')" :disabled="!$hasAccess('update')"
                v-if="scope.row.ExamState === 1">编辑</el-button>
              <el-button size="mini" @click.native="handleEvent(scope.row, 'publish')"
                :disabled="!$hasAccess('publish')"
                v-if="scope.row.ExamState === 1 && scope.row.IsPublished === 0">发布</el-button>
              <el-button size="mini" @click.native="handleEvent(scope.row, 'delete')" :disabled="!$hasAccess('delete')"
                v-if="scope.row.ExamState === 1">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @size-change="searchList" @current-change="findList" :current-page.sync="pageNo"
          :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[15, 30, 45, 60]"
          :total="total" class="float-right mt-20px ml-10px"></el-pagination>
      </div>
    </div>
    <ExamPlanForm v-else :pageType="operateType" @refreshList="refreshList" :operateData="operateData"
      @cancel="checkComp('TABLE')"></ExamPlanForm>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import DiyService from '@/modules/educational-training-management-sm/services/DiyService'
import ExamPlanForm from '../../components/examManageConstructionUnit/ExamPlanForm'


export default {
  name: 'exam-plan',
  components: {
    ExamPlanForm
  },
  filters: {
    formatDate(val, format = 'YYYY-MM-DD HH:mm:ss') {
      if (!val) return ''
      return dayjs(val).format(format)
    }
  },
  data() {
    return {
      nowTime: dayjs(),
      timer: null,
      tableData: [],
      loading: false,
      exportLoading: false,
      exportTimer: null,
      searchData: {
        ExamName: '',
        ExamCode: '',
        StartTime: '',
        EndTime: ''
      },
      currentComp: 'TABLE',
      total: 0,
      pageNo: 1,
      pageSize: 15,
      operateType: '',
      operateData: {},
      selectedRows: []
    }
  },
  watch: {
    '$route'(to, from) {
      if (to && to.fullPath) {
        this.refreshList()
      }
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 54px)'
    }
  },
  methods: {
    refreshList() {
      this.checkComp('TABLE')
      this.searchList()
    },
    handleEvent(row, type) {
      if (type === 'delete') {
        this.$confirm('是否删除该记录？', '提示', {
          type: 'warning'
        }).then(async () => {
          const [err] = await DiyService.deleteFormData({
            TableName: 'diy_ExaminationPlan',
            Id: row.Id
          })
          if (!err) {
            this.$message.success('删除成功')
            this.findList()
          }
        }).catch(() => { })
        return
      }
      if (type === 'publish') {
        this.$confirm('请确认是否发布该计划？', '提示', {
          type: 'warning'
        }).then(async () => {
          this.loading = true
          const [err, res] = await DiyService.getInterfaceList({
            ApiEngineKey: 'publish_exam_plan',
            PlanId: row.Id
          })
          if (!err && res.Code === 1) {
            this.$message.success('发布成功')
          } else {
            this.$message.error(res.Msg)
          }
          this.loading = false
          this.findList()
        }).catch(() => { })
        return
      }
      if (row?.ExamState === 3) {
        const url = Wiz?.globalSettings?.globalConfig?.routerBase
          ? `/${Wiz.globalSettings.globalConfig.routerBase}/educational-training-management-sm/exam-manage-construction-unit/exam-record-info`
          : '/educational-training-management-sm/exam-manage-construction-unit/exam-record-info'
        const query = {
          id: row.Id
        }
        if (row.sessionId) {
          query.sessionId = row.sessionId
        }
        if (row.makeUpExamRootNodeId) {
          query.mainSessionId = row.makeUpExamRootNodeId
        }
        this.$router.push({
          path: url,
          query
        })
      }
      this.operateType = type
      this.operateData = row
      this.checkComp('action')
    },
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    resetText() {
      this.searchData = this.$options.data().searchData
      this.searchList()
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
    async findList() {
      this.loading = true
      try {
        const [err, res] = await DiyService.getInterfaceList({
          ApiEngineKey: 'get_examination_plan_list',
          pageSize: this.pageSize,
          PageIndex: this.pageNo,
          ...this.searchData
        })
        const statelist = [
          { value: 1, label: '未开始' },
          { value: 2, label: '进行中' },
          { value: 3, label: '已结束' }
        ]
        if (!err && res.Code === 1) {
          this.tableData = res.Data.map(item => ({
            ...item,
            ExamStateName: statelist.find(i => i.value === item.ExamState).label
          }))

          this.total = res.DataCount
        } else {
          this.$message.error(res.Msg)
        }
      } finally {
        this.loading = false
      }
    },
    async handleExport() {
      if (this.exportTimer) {
        return
      }

      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message.warning('请选择要导出的数据')
        return
      }

      this.exportLoading = true
      this.exportTimer = setTimeout(() => {
        this.exportTimer = null
      }, 1000)

      try {
        const params = {
          ...this.searchData,
          IdList: this.selectedRows.map(item => item.Id).join(','),
          ApiEngineKey: 'export_exam_plan_list'
        }
        const res = await DiyService.getInterfaceList(params)
        if (res[1].Code === 1) {
          if (!res[1].Data?.FileByteBase64) {
            this.$message.error('导出数据格式错误')
            return
          }
          try {
            const binaryString = window.atob(res[1].Data.FileByteBase64)
            const bytes = new Uint8Array(binaryString.length)
            for (let i = 0; i < binaryString.length; i++) {
              bytes[i] = binaryString.charCodeAt(i)
            }
            const blob = new Blob([bytes], { 
              type: res[1].Data.ContentType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = res[1].Data.FileName || `考试计划${dayjs().format('YYYY-MM-DD')}.xlsx`
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
          } catch (decodeError) {
            this.$message.error('文件解码失败')
          }
        } else {
          this.$message.error(res[1].Msg || '导出失败')
        }
      } catch (error) {
        this.$message.error('导出失败')
      } finally {
        this.exportLoading = false
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    }
  },
  created() {
    this.searchList()
    this.timer = setInterval(() => {
      this.nowTime = dayjs()
    }, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  activated() {
    this.searchList()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
  padding: 10px;
}
</style>
